let items = document.querySelectorAll(".mega-menu");
let header = document.querySelector('header');
let currentItemIndex;

items.forEach((item, itemIndex) => {
  const content = item.querySelector(".mega-menu__content");
  const summary = item.querySelector("summary");

  // Add click event listener to the summary element
  summary.addEventListener("click", function(event) {
    // Check if the event was generated by a mouse click
    if (event.detail !== 0) {
      // This is a mouse click
      event.preventDefault();
      // Navigate to the href of the link inside the summary
      const link = this.querySelector("a");
      if (link) {
        window.location.href = link.href;
      }
    }
    // If event.detail === 0, it's a keyboard event; let it proceed to open the menu
  });

  item.addEventListener("mouseover", () => {
    if (
      (currentItemIndex === 0 && currentItemIndex !== itemIndex) ||
      (currentItemIndex && currentItemIndex !== itemIndex)
    ) {
      items[currentItemIndex].removeAttribute("open");
    }

    currentItemIndex = itemIndex;
    item.setAttribute("open", "");
    summary.setAttribute("aria-expanded", true);
    
    // Add the class to the body when a menu opens
    document.body.classList.add('menu-open');
  });

  item.addEventListener("mouseleave", (event) => {
    let close = true;

    const closeTimeout = setTimeout(() => {
      if (close) {
        item.removeAttribute("open");
        summary.setAttribute("aria-expanded", false);
        // Remove the class from the body when the menu times out and closes
        document.body.classList.remove('menu-open');
      }
    }, 400);
    
    content.addEventListener("mouseover", () => {
      close = false;
    });

    item.addEventListener("mouseover", () => {
      clearTimeout(closeTimeout);
    });
  });

  content.addEventListener("mouseleave", () => {
    item.removeAttribute("open");
    summary.setAttribute("aria-expanded", false);
    // Remove the class from the body when leaving the mega menu content directly
    document.body.classList.remove('menu-open');
  });
});